import React, { useState } from 'react';
import { ArrowRightIcon, MapPinIcon, UserIcon, PhoneIcon, MailIcon, CheckCircleIcon } from 'lucide-react';
interface CashOfferFormProps {
  buttonText?: string;
  className?: string;
}
export function CashOfferForm({
  buttonText = 'Get My Cash Offer',
  className = ''
}: CashOfferFormProps) {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [smsConsent, setSmsConsent] = useState(false);
  const [formData, setFormData] = useState({
    address: '',
    name: '',
    phone: '',
    email: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
    }, 1500);
  };
  return <div className={`w-full ${className}`} data-id="element-31">
      {!isSubmitted ? <form onSubmit={handleSubmit} className="space-y-4" data-id="element-32">
          {/* Property Address */}
          <div className="relative" data-id="element-33">
            <MapPinIcon className="absolute left-3.5 top-3.5 w-5 h-5 text-slate-400" data-id="element-34" />
            <input type="text" name="address" value={formData.address} onChange={handleChange} placeholder="Property address" className="w-full pl-10 pr-4 py-3 rounded-full border border-slate-300 focus:ring-2 focus:ring-[#D4A24C] focus:border-[#D4A24C] outline-none transition-colors text-slate-900 placeholder:text-slate-400" required data-id="element-35" />
          </div>

          {/* Name */}
          <div className="relative" data-id="element-36">
            <UserIcon className="absolute left-3.5 top-3.5 w-5 h-5 text-slate-400" data-id="element-37" />
            <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your full name" className="w-full pl-10 pr-4 py-3 rounded-full border border-slate-300 focus:ring-2 focus:ring-[#D4A24C] focus:border-[#D4A24C] outline-none transition-colors text-slate-900 placeholder:text-slate-400" required data-id="element-38" />
          </div>

          {/* Phone */}
          <div className="relative" data-id="element-39">
            <PhoneIcon className="absolute left-3.5 top-3.5 w-5 h-5 text-slate-400" data-id="element-40" />
            <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone number" className="w-full pl-10 pr-4 py-3 rounded-full border border-slate-300 focus:ring-2 focus:ring-[#D4A24C] focus:border-[#D4A24C] outline-none transition-colors text-slate-900 placeholder:text-slate-400" required data-id="element-41" />
          </div>

          {/* Email */}
          <div className="relative" data-id="element-42">
            <MailIcon className="absolute left-3.5 top-3.5 w-5 h-5 text-slate-400" data-id="element-43" />
            <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email address" className="w-full pl-10 pr-4 py-3 rounded-full border border-slate-300 focus:ring-2 focus:ring-[#D4A24C] focus:border-[#D4A24C] outline-none transition-colors text-slate-900 placeholder:text-slate-400" required data-id="element-44" />
          </div>

          {/* A2P / TCPA Consent Checkbox */}
          <label className="flex items-start gap-3 cursor-pointer pt-1 select-none" data-id="element-45">
            <input type="checkbox" checked={smsConsent} onChange={e => setSmsConsent(e.target.checked)} required className="mt-1 w-4 h-4 rounded border-slate-300 text-[#D4A24C] focus:ring-[#D4A24C] focus:ring-offset-0 cursor-pointer flex-shrink-0 accent-[#D4A24C]" data-id="element-46" />
            <span className="text-[11px] leading-snug text-slate-600" data-id="element-47">
              By checking this box, I expressly consent to receive recurring
              marketing and informational calls and SMS/MMS text messages from
              Nationwide Home Buyers at the phone number provided, including
              messages sent using an automatic telephone dialing system or
              prerecorded/artificial voice. Consent is not a condition of
              purchase. Msg & data rates may apply. Msg frequency varies. Reply
              STOP to opt out or HELP for help. View our{' '}
              <a href="#/privacy" className="text-[#D4A24C] hover:underline font-medium" data-id="element-48">
                Privacy Policy
              </a>{' '}
              and{' '}
              <a href="#/terms" className="text-[#D4A24C] hover:underline font-medium" data-id="element-49">
                Terms of Service
              </a>
              .
            </span>
          </label>

          <button type="submit" disabled={isSubmitting || !smsConsent} className="w-full bg-[#D4A24C] hover:bg-[#B8862F] text-white font-bold py-4 px-6 rounded-full transition-colors flex items-center justify-center group disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-50">
            {isSubmitting ? <span className="flex items-center" data-id="element-51">
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-52">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-53"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-54"></path>
                </svg>
                Processing...
              </span> : <>
                {buttonText}
                <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-55" />
              </>}
          </button>
        </form> : <div className="text-center py-8 px-4 bg-green-50 rounded-2xl border border-green-100" data-id="element-56">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-57">
            <CheckCircleIcon className="w-8 h-8 text-green-600" data-id="element-58" />
          </div>
          <h3 className="text-2xl font-bold text-[#0F172A] mb-2" data-id="element-59">
            Offer Request Received!
          </h3>
          <p className="text-slate-600" data-id="element-60">
            We're reviewing your property details and will call you at{' '}
            <span className="font-semibold" data-id="element-61">{formData.phone}</span> within 24
            hours with your cash offer.
          </p>
        </div>}
    </div>;
}